// extracted by mini-css-extract-plugin
export var lg = "_41-4";
export var md = "_41-3";
export var sm = "_41-2";
export var xs = "_41-1";
export var xxs = "_41-0";